import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core'

import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { TableCellHead, TableContainer } from 'src/components'
import NoResultsTable from 'src/components/NoResultsTable'
import { apiSauceInstance } from 'src/services/api'
import { formatDate } from 'src/utils/formatters'

import store from '../../store/historico-integracao-store'
import { HistoricoIntegracao } from '../../types/historico-integracao'

interface ModalHistoricoIntegracaoProps {
  programacaoId: string | number | undefined
}

export const ModalHistoricoIntegracao = observer(
  ({ programacaoId }: ModalHistoricoIntegracaoProps) => {
    const [historicoIntegracoes, setHistoricoIntegracoes] = useState<
      HistoricoIntegracao[]
    >([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
      async function getHistoryIntegrations() {
        if (!programacaoId || !store?.modalHistorico) return

        setLoading(true)
        try {
          const response = await apiSauceInstance.get<HistoricoIntegracao[]>(
            `/programacoes/${programacaoId}/history-integration`
          )

          if (response.ok && response.data) {
            setHistoricoIntegracoes(response.data)
          }
        } catch (error) {
          console.error('Erro ao buscar histórico de integração:', error)
        } finally {
          setLoading(false)
        }
      }

      getHistoryIntegrations()
    }, [programacaoId, store?.modalHistorico])

    const temItens = historicoIntegracoes.length > 0

    return (
      <Dialog
        open={store?.modalHistorico}
        onClose={() => store?.closeModalHistorico()}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>Histórico Integração</DialogTitle>

        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TableContainer
                totalCount={historicoIntegracoes.length}
                loading={loading}
                disabledPagination
              >
                {temItens ? (
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCellHead label="Status" />
                        <TableCellHead label="Mensagem" />
                        <TableCellHead label="Data" />
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {historicoIntegracoes.map((programacao, index) => (
                        <TableRow key={programacao?.id || index}>
                          <TableCell>{programacao.status}</TableCell>
                          <TableCell>
                            {programacao.status === 'ERRO'
                              ? programacao.mensagemErro
                              : JSON.stringify(programacao.resposta)}
                          </TableCell>
                          <TableCell>
                            {formatDate(programacao.createdAt)}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                ) : (
                  <NoResultsTable loading={loading} />
                )}
              </TableContainer>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    )
  }
)
